import { useContext, useEffect, useState } from 'react';
import { ProdutoContext } from '../../../../context/product';
import ReactSelect from '../../../data/reactSelect';
import Layout from '../../../data/Layout';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import { SiUnity } from 'react-icons/si';
import ModalUnit from '../FormProduto/ModalUnit';
import * as S from '../styled';
import ReactSelectFornecedor from '../../../data/reactSelectFornecedor';
import { useDispatch } from 'react-redux';
import Globals from '../../../../Globals.json';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';

export default function UnidadeOperacao() {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const dispatch = useDispatch<AppDispatch>();
  const [show, setShow] = useState<boolean>(false);

  const { unit, setUnit, typeOper, setTypeOper, validUnit } =
    useContext(ProdutoContext);

  const {
    data: purpose,
    isLoading: isLoadingPurpose,
    isError: isErrorPurpose,
  } = useQueryFetchPages<any>(['purpose'], `${Globals.api.purposes}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });

  const {
    data: measure,
    isLoading: isLoadingMeasure,
    isError: isErrorMeasure,
  } = useQueryFetchPages<any>(['measure'], `${Globals.api.measure}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });

  useEffect(() => {
    setTypeOper(1);
  }, []);

  useEffect(() => {
    if (!unit) {
      setUnit(
        measure?.data?.find((item: any) => item?.name === 'Unidade')
          ?.id_pdv_measure
      );
    }
  }, [measure]);

  return (
    <>
      <ModalUnit
        show={show}
        setShow={setShow}
        dispatch={dispatch}
        setMeasureUnitList={measure}
      />
      <Layout title="Unidade e Operação">
        <S.Wrapper>
          <ReactSelectFornecedor
            label="Uni. Médida"
            isClearable
            options={measure?.data?.map((item: any) => ({
              value: item.id_pdv_measure,
              label: item.name,
              store_id: item.store_id,
            }))}
            state={unit}
            setState={setUnit}
            placeholder="Und de medida principal"
            isInvalid={validUnit}
            setShow={setShow}
            icon={<SiUnity />}
            isLoading={isLoadingMeasure}
            isDisabled={isLoadingMeasure}
          />

          <ReactSelect
            label="Tip. operação"
            isClearable
            options={purpose?.data?.map((item: any) => ({
              value: item.id,
              label: item.product_purpose_description,
              store_id: item.store_id,
            }))}
            state={typeOper}
            setState={setTypeOper}
            placeholder="Tipo de operação"
            isLoading={isLoadingPurpose}
            isDisabled={isLoadingPurpose}
          />
        </S.Wrapper>
      </Layout>
    </>
  );
}
